import $ from 'jquery'

export default {
  payContent: '',
  payStart (content) {
    if (!content) {
      alert('参数缺失！')
    }

    this.payContent = content

    let ALIPAYBOX = $('#ALIPAYBOX')

    if (ALIPAYBOX) {
      ALIPAYBOX.remove()
    }

    let payElement = $(this.payContent)
    payElement.attr('id', 'ALIPAYBOX')

    $('body').append(payElement)
  }
}
